import Vue from 'vue';
import Vuex from 'vuex';
import SystemModule from './modules/system';
import UserModule from './modules/user';
import GroupModule from './modules/group';
import TwitterCrisisMonitorModule from './modules/twitter-crisis-monitor/index';
import DashboardModule from './modules/dashboard';
import HomeSettingsModule from './modules/home-settings';
import NpsModule from './modules/nps';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    system: SystemModule,
    user: UserModule,
    group: GroupModule,
    dashboard: DashboardModule,
    twitterCrisisMonitor: TwitterCrisisMonitorModule,
    homeSettings: HomeSettingsModule,
    nps: NpsModule,
  },
});
